import Widget from "../../Widget";
import IntlMessages from "../../../util/IntlMessages";

const Page = ({ children}) => {
    
    return (
      <Widget>
        {children}
      </Widget>
    )
  };
  
  export default Page;
